module.exports = " <div class=\"tabs-striped tabs-{{ position }} tabs-background-{{ bgColor }} tabs-color-{{ tabColor }}\" _v-e15ac080=\"\"> <div class=tabs _v-e15ac080=\"\"> <a v-for=\"(index, tabItem) in tabItems\" class=tab-item :class=\"{'active': activeIndex == index}\" @click=tabChanged(index) _v-e15ac080=\"\"> {{ tabItem }} </a> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-e15ac080!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/index.vue
// module id = 265
// module chunks = 0